import React from "react";
import StageHeader from "./StageHeader";

import { CommandBlock } from "../common/Commands2";

export default function CommandsStage({ system, period, stage, stageIndex }) {
  return (
    <>
      <StageHeader stageIndex={stageIndex} stage={stage} />

      <CommandBlock
        endpoint={`/bill/${system}/${period}/${stage.stage}/commands`}
        enabled
        schedule
        summarize
      />
    </>
  );
}
